
import'./App.css';
import Table from './Table';

function App() {
  return (
    <div className="App">
    <Table />
    </div>
  );
}

export default App;
